import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Article from "../pages/article/page";
import Products from "../pages/products/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/pt",
    element: <Home />,
  },
  {
    path: "/en",
    element: <Home />,
  },
  {
    path: "/de",
    element: <Home />,
  },
  {
    path: "/article/:slug",
    element: <Article />,
  },
  {
    path: "/pt/article/:slug",
    element: <Article />,
  },
  {
    path: "/en/article/:slug",
    element: <Article />,
  },
  {
    path: "/de/article/:slug",
    element: <Article />,
  },
  {
    path: "/products",
    element: <Products />,
  },
  {
    path: "/pt/products",
    element: <Products />,
  },
  {
    path: "/en/products",
    element: <Products />,
  },
  {
    path: "/de/products",
    element: <Products />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;